import type { IconSvgObject } from './types';

const Select01Icon: IconSvgObject = [
  ["path", { d: "M5 2V8M2 5H8", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "0" }],
  ["path", { d: "M12 5H15M12 22H15M18 5H18.5C20.433 5 22 6.567 22 8.5V9M22 18V18.5C22 20.433 20.433 22 18.5 22H18M9 22H8.5C6.567 22 5 20.433 5 18.5L5 18M22 12V15M5 12L5 15", stroke: "currentColor", strokeLinecap: "round", strokeWidth: "1.5", key: "1" }]
];

export default Select01Icon;
